import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user' // Import your user store

export default function (route) {
    const userStore = useUserStore()
    try {
        if(getCookie('token') == null && route.fullPath.indexOf('auth') == -1 && route.fullPath.indexOf('user') != -1 && route.fullPath.indexOf('confirm') == -1) {
            location.href = '/lk/auth/';
            return;
        }
    } catch(e) {
        console.log(e)
    }
    if(userStore.user != null) {
        if(route.fullPath.indexOf('admin') !== -1) {
            if(userStore.user.account.person_group.id != 7) {
                navigateTo('/')
                return;
            }
        }
        if(route.fullPath.indexOf('teacher') !== -1 || route.fullPath.indexOf('staff') !== -1) {
            if(userStore.user.account.person_group.id == 1) {
                navigateTo('/')
                return;
            }
        }
    }
//   const router = useRouter()
//   const userStore = useUserStore()
//   await userStore.loading()
//   const isAuth = userStore.user != null

//   try {
//     if (route.fullPath === '/user/auth' && isAuth) {
//       router.push('/user')
//     }
//     if (route.fullPath === '/user' && !isAuth) {
//       router.push('/user/auth')
//     }
//   } catch (error) {
//   }

return true;
}
function getCookie(cookieName) {
    try {
        const name = cookieName + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
  
    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    } catch(e) {}
  
    return null; // Return null if the cookie with the specified name is not found
  }